import { ReactNode } from 'react'

import UserLayout from '../../components/layouts/UserLayout'
import { useAuth } from '../../components/containers/AuthContainer'
import { FormProvider } from '../../components/containers/FormContainer'

function Auth({ children }: { children: ReactNode }): JSX.Element {
  const { isAuthenticated } = useAuth()

  return isAuthenticated() ? (
    <FormProvider>
      <UserLayout>{children}</UserLayout>
    </FormProvider>
  ) : (
    <>{children}</>
  )
}

export default Auth
